import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import PageTitle from "../../Agency/PageTitle";
import Icon from "../../components/Icons/Icon";
import DashboardNotification from "../Notification/DashboardNotification";
import WellComeWidget from "./WellComeWidget";
import NurseAndCareGiverEmployeeStore from "../../Store/NurseAndCareGiverEmployeeStore";
import ScheduleNotification from "./ScheduleNotification";
import GlobelStore from "../../Store/GlobelStore";
import ClientWidget from "./ClientWidget";

const Dashboard = observer(() => {
  const [newScheduleData, setNewScheduleData] = useState([]);

  useEffect(() => {
    GlobelStore.getDashboardData();
  }, []);

  useEffect(() => {
    const data = GlobelStore?.dashboardAllData?.upcomingScheduleCount;
    setNewScheduleData(data);
  }, [GlobelStore?.dashboardAllData?.upcomingScheduleCount]);

  return (
    <div>
      <div className="pageHeaderContainer">
        <PageTitle
          icon={<Icon iconName="menu" />}
          headerTitle="Dashboard"
          subHeaderTitle=" Navigation/Dashboard"
        />
      </div>
      <div className="pageMainContainer">
        <div className="dashboardGridScheduleNotificationContainer">
          {newScheduleData > 0 && (
            <ScheduleNotification newScheduleData={newScheduleData} />
          )}
        </div>
        <div className="dashboardGridContainer">
          <WellComeWidget />
          <DashboardNotification />
        </div>
        <div className="dashboardGridContainer">
          {GlobelStore?.dashboardAllData?.totalConnectedClients && (
            <ClientWidget />
          )}
        </div>
      </div>
    </div>
  );
});

export default React.memo(Dashboard);
